import { SVGIconComponent } from './types';

export const ProjectTypeLink: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/link" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill="#848484"
        d="M4.55 1c.25 0 .553.105.752.259l2.572 1.98h6.268c.797 0 1.445.665 1.445 1.483v1.794h1.422c.336 0 .632.145.812.395s.227.583.128.913l-2.667 8.899a.384.384 0 0 1-.366.277H.304a.29.29 0 0 1-.288-.295L0 2.485C0 1.665.648 1 1.445 1zm2.204 9.5c-.13 0-.25.05-.341.142l-1.099 1.105a2.76 2.76 0 0 0-.814 1.985c0 .698.253 1.364.71 1.878a2.68 2.68 0 0 0 1.95.889 2.98 2.98 0 0 0 2.191-.875l1.008-1.014a.49.49 0 0 0 0-.687.48.48 0 0 0-.683 0l-1.008 1.013c-.389.39-.936.6-1.481.59a1.72 1.72 0 0 1-1.257-.565 1.85 1.85 0 0 1-.463-1.233 1.8 1.8 0 0 1 .531-1.293l1.098-1.105a.488.488 0 0 0-.342-.83m4.221-1a.52.52 0 0 0-.371.154l-3.95 3.953a.524.524 0 0 0 0 .744.537.537 0 0 0 .742 0l3.95-3.954a.527.527 0 0 0-.37-.897m-.139-2a3 3 0 0 0-2.194.879l-1 1.008a.49.49 0 0 0 0 .688c.188.19.494.19.682 0l1.001-1.007c.377-.38.896-.595 1.431-.595h.055c.499.014.946.215 1.26.568A1.844 1.844 0 0 1 12 11.565l-1.097 1.105a.49.49 0 0 0 0 .688c.188.19.495.189.683 0l1.097-1.105a2.8 2.8 0 0 0 .818-1.983 2.82 2.82 0 0 0-.711-1.88 2.68 2.68 0 0 0-1.953-.89M4.52 2.378H1.445a.106.106 0 0 0-.104.107v9.591L2.73 7.44c.155-.518.69-.924 1.219-.924h10.296l.001-1.794a.107.107 0 0 0-.104-.108H7.844c-.25 0-.55-.103-.75-.256z"
      />
    </g>
  </svg>
);
